var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const Svg3Dots = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 36,
  height: 36,
  viewBox: "0 0 36 36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18 23C19.1046 23 20 23.8954 20 25C20 26.1046 19.1046 27 18 27C16.8954 27 16 26.1046 16 25C16 23.8954 16.8954 23 18 23Z",
  fill: "#BFC1C7"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M18 16C19.1046 16 20 16.8954 20 18C20 19.1046 19.1046 20 18 20C16.8954 20 16 19.1046 16 18C16 16.8954 16.8954 16 18 16Z",
  fill: "#BFC1C7"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M20 11C20 9.89543 19.1046 9 18 9C16.8954 9 16 9.89543 16 11C16 12.1046 16.8954 13 18 13C19.1046 13 20 12.1046 20 11Z",
  fill: "#BFC1C7"
})));
export { Svg3Dots as ReactComponent };